import BGBTC from './assets/BGBTC.json';
import { prEnvironment } from './config';
export const contractInfo = {
  // 测试
  address: prEnvironment
    ? '0x55d1f1879969bdbB9960d269974564C58DBc3238' // 正式
    : '0xaf8883209D225561330f038Fa56216DD71Ce19Be', // 测试
  abi: BGBTC.abi,
  contractName: 'BGB Staking',
  contractIcon:
    'https://img.bgstatic.com/multiLang/coinPriceLogo/ef15a6bddc21034ca383c1fcdb8ed9fe1710522385430.png',
};
